import { requestGetJSON } from '../../../../NonReact/common/API/REST/RESTAPIClient'
import { requestJSON } from '../../../../NonReact/common/API/REST/RESTClient'
import { RESTMethods } from '../../../../NonReact/constants/REST'
import { databaseSettingsURL, NO_CACHE_TIME } from '../../../../NonReact/constants/ApiConstants'
import type {
    DatabaseSettingsMutationResponse,
    DatabaseSettingsPutRequest,
    DatabaseSettingsResponse
} from '../../../../NonReact/Types/DatabaseSettingsTypes'

/**
 * Loads the current database maintenance interval settings.
 */
export const getDatabaseSettings = (): Promise<Nullable<DatabaseSettingsResponse>> =>
    requestGetJSON<DatabaseSettingsResponse>(databaseSettingsURL(), {
        cacheTime: NO_CACHE_TIME
    })

/**
 * Updates the database maintenance interval settings.
 *
 * @param payload Updated field values.
 */
export const putDatabaseSettings = (
    payload: DatabaseSettingsPutRequest
): Promise<Nullable<DatabaseSettingsMutationResponse>> =>
    requestJSON<DatabaseSettingsMutationResponse, DatabaseSettingsPutRequest>(databaseSettingsURL(), {
        method: RESTMethods.PUT,
        body: payload
    })
